import { Form, InputGroup } from 'react-bootstrap';

import './TextInput.scss';

const TextInput = ({
  prepend,
  append,
  inputProps,
  label = null,
  parentClassName,
  footerLabel = null,
  isRequired = false,
  feedBackMessage = null,
}) => (
  <div className="generic-text-input-wrapper">
    {label && (
      <label className="m-0">
        {label}

        {isRequired && <span className="mandatory-field"> *</span>}
      </label>
    )}

    <InputGroup className={`input-box-generic ${parentClassName}`}>
      {prepend && <InputGroup.Prepend>{prepend}</InputGroup.Prepend>}

      <Form.Control {...inputProps} />

      {append && <InputGroup.Append>{append}</InputGroup.Append>}
    </InputGroup>

    {footerLabel && (
      <label className="m-0 footer-label-text">{footerLabel}</label>
    )}

    {feedBackMessage && (
      <Form.Control.Feedback
        type="invalid"
        className={feedBackMessage ? 'input-field-feedback' : ''}
      >
        <span role="alert">{feedBackMessage}</span>
      </Form.Control.Feedback>
    )}
  </div>
);

export default TextInput;
